module.exports = __webpack_public_path__ + "accd62a988b25133b82b6fae04ad9de7.MP3";